import { Utils } from '../classes/Utils';
import moment from 'moment';
import { GT_OSGB } from '../geotools';
import { logPlanningView, hasSeen, setCursor } from '../helpers';
import { ServiceCalls } from '../serviceCalls';
const util = new Utils();
const intro = "<tr><td class='left-float'><b>";
const translateLabel = label => {
  const trans = {
    vw_crossrail_route: 'vw_crossrail',
    vw_crossrail_station: 'vw_crossrail',
    vw_underground_stations: 'vw_underground',
    vw_underground_lines: 'vw_underground',
    rofrs_ea_v201905: 'vw_rofrs',
    vw_rofrs_157: 'vw_rofrs',
  };
  return trans[label] || label;
};
var updateQueryStringParameter = function (uri, key, value) {
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
};
export function closeWMS({ state, ol }) {
  $('#wms-info-panel').hide();
  state.planningOn = false;
  state.lineSearchOn = false;
  state.heldjson = '';
  ol.layers.vectorPin.destroyFeatures([ol.points.marker2]);
}
const getLabelFromID = ({ id, state }) => {
  if (state.layerProps[id]) return state.layerProps[id].label;
  else return util.correct(`title:${id}`);
};
const getPropFromID = ({ id, key, state }) => {
  if (state.layerProps[id] && id !== 'highways') {
    if (state.layerProps[id] && state.layerProps[id].props[key]) {
      return state.layerProps[id].props[key].label;
    } else return null;
  }
  if (util.correct(key, id)) return util.correct(key, id);
  else return util.correct(key);
};
function processWMSInfo({ json, state, proxy }) {
  if (json.geometry) {
    json.features = [json];
  }
  if (json.features) {
    json.features = json.features.filter(feature => {
      const id = feature.pid ? feature.pid.split('.')[0] : feature.id.split('.')[0];
      let id2;
      if (feature.attributes && feature.attributes.fsProxy) id2 = feature.attributes.fsProxy;
      else if (state.wmsQuery && state.wmsQuery[id]) id2 = state.wmsQuery[id];
      else if (proxy) id2 = proxy;
      const label = getLabelFromID({ id: id2 || id, state });
      if (!label) return false;
      return true;
    });
  }

  json.features = json.features.filter(function (thing, index, self) {
    var props = thing.properties;
    if (thing.id.indexOf('highway') === -1) return true;
    if (!props.roadname || !props.highwayauthorityname || !props.usrn) return true;
    return (
      index ===
      self.findIndex(function (t) {
        var tprops = t.properties;
        return tprops.roadname === props.roadname && tprops.highwayauthorityname === props.highwayauthorityname;
      })
    );
  });
  return json;
}
export function showWMSInfo({ evt, state, ol, settings }) {
  let proxy;
  if (evt && evt.object && evt.object.layers) {
    evt.object.layers.forEach(o => {
      if (o.url && o.url.includes('/proxy')) o.params.LAYERS = o.params.LAYERS.split(':')[0];
    });
  }
  if (!evt.fromWFS && evt.feature && evt.feature.layer && evt.feature.layer.proxy) proxy = evt.feature.layer.proxy;
  setCursor({ type: 'progress' });
  var pos = ol.map.getLonLatFromPixel(evt.xy);
  var pos2 = new OpenLayers.Geometry.Point(pos.lon, pos.lat);
  state.curMouseXY = pos;
  if (ol.points.marker2) {
    ol.layers.vectorPin.destroyFeatures([ol.points.marker2]);
  }
  var json;
  const tLayer = (evt && evt.layer && evt.layer.name) || '';
  if (!evt.fromWFS && evt.object && evt.object.layerUrls && evt.object.layerUrls[0].includes('proxy'))
    state.proxyReturned = true;
  else if (evt.fromWFS) state.wfsReturned = true;
  else state.findReturned = true;
  let canShow =
    ((state.hasFind && state.findReturned) || !state.hasFind) &&
    ((state.hasProxy && state.proxyReturned) || !state.hasProxy);
  if (!canShow && tLayer !== 'planningLayer_Vector' && tLayer !== 'lineSearchLayer_Vector') {
    if (!state.heldjson || !state.heldjson.features) state.heldjson = { features: [] };
    if (evt.text) {
      const processed = processWMSInfo({ json: evt.text ? JSON.parse(evt.text) : evt, state, proxy });
      if (processed && processed.features && processed.features.length)
        processed.features.forEach(p => {
          state.heldjson.features.push(p);
        });
    }
  } else {
    state.proxyReturned = false;
    state.wfsReturned = false;
    state.findReturned = false;
    ol.arrays.wmsArray = [];
    ol.arrays.wmsFeatureArray = {};
    if (evt.text) {
      json = processWMSInfo({ json: JSON.parse(evt.text), state, proxy });
      if (state.planningOn || state.lineSearchOn || (state.hasProxy && state.hasWFS)) {
        if (state.heldjson) {
          for (var n = state.heldjson.features.length - 1; n >= 0; n--) {
            var feat = state.heldjson.features[n];
            json.features.unshift(feat);
          }
        }
        state.heldjson = json;
      }
    } else {
      if (evt.layer.name === 'planningLayer_Vector') {
        var arr = [];
        for (var i = 0; i < evt.attributes.length; i++) {
          var curFeat = jQuery.extend(true, {}, evt);
          curFeat.properties = evt.attributes[i];
          curFeat.pid = 'planningapplications.' + Math.round(Math.random() * 100000).toString();
          arr.push(curFeat);
        }
        //    evt.properties = evt.attributes;
        json = { features: arr };
        state.heldjson = json;
        state.planningOn = true;
      } else if (evt.layer.name === 'lineSearchLayer_Vector') {
        var arr2 = [];
        for (var i2 = 0; i2 < evt.attributes.length; i2++) {
          var curFeat2 = jQuery.extend(true, {}, evt);
          curFeat2.properties = evt.attributes[i2];
          if (i2 == 0) curFeat2.pid = `linesearch.${Math.round(Math.random() * 100000).toString()}`;
          else if (i2 == 1) curFeat2.pid = `linesearchUnaffected.${Math.round(Math.random() * 100000).toString()}`;
          else curFeat2.pid = `linesearchNon.${Math.round(Math.random() * 100000).toString()}`;
          arr2.push(curFeat2);
        }
        //    evt.properties = evt.attributes;
        json = { features: arr2 };
        state.heldjson = json;
        state.lineSearchOn = true;
      }
    }
    $('#wms-info-panel .content').empty();
    $('#wms-info-panel .foot-left').empty();
    $('#wms-info-panel .foot-right').empty();
    if (state.heldjson && state.heldjson.features) {
      if (json.features.length) {
        state.heldjson.features.forEach(f => {
          json.features.push(f);
        });
      }
    }
    if (typeof json.features !== 'undefined') {
      json.features = json.features.filter(
        (j, index, self) =>
          index ===
          self.findIndex(t => {
            if (t.pid) return t.pid === j.pid;
            else return t.id === j.id;
          }),
      );
      if (json.features.length > 0) {
        var features = json.features;
        let layerID = -1;
        let oldLayer = '';
        $.each(features, function (index, feature) {
          var rl = feature.pid ? feature.pid.split('.')[0] : feature.id.split('.')[0];
          if (rl !== oldLayer) {
            layerID++;
            oldLayer = rl;
          }
          let layerName = `layer_${layerID}~${rl}`;
          var noAdd = false;

          if ($.inArray(rl, util.layergroups) > -1) {
            layerName = `highways`;
          }
          if (typeof ol.arrays.wmsFeatureArray[layerName] === 'undefined') {
            ol.arrays.wmsFeatureArray[layerName] = [];
          }
          if (typeof feature.properties.streettype !== 'undefined') {
            if (feature.properties.streettype == 'Numbered Street') noAdd = true;
          }
          if (!noAdd) ol.arrays.wmsFeatureArray[layerName].push(feature);
        });
        $('#wms-info-tabs').empty();
        if ($.isArray(features)) {
          var index = -1;
          $.each(ol.arrays.wmsFeatureArray, function (ix, featurearr) {
            $.each(featurearr, function (idx, feature) {
              if (feature.properties.source) {
                util.populateCountry(feature.properties.source);
              }
              if (feature.properties.data_source) {
                util.populateCountry(feature.properties.data_source);
              }
              index++;
              var rawlabel = feature.pid ? feature.pid.split('.')[0] : feature.id.split('.')[0];
              let rawlabel2;
              if (feature.attributes && feature.attributes.fsProxy) rawlabel2 = feature.attributes.fsProxy;
              else if (feature.properties && feature.properties.fsProxy) rawlabel2 = feature.properties.fsProxy;
              else if (state.wmsQuery && state.wmsQuery[rawlabel]) rawlabel2 = state.wmsQuery[rawlabel];
              else if (proxy) rawlabel2 = proxy;
              var label = 'title:' + rawlabel;
              if ($.inArray(rawlabel, util.layergroups) > -1) {
                label = 'title:highways';
                rawlabel = 'highways';
              }
              if (idx === 0) {
                if (index === 0)
                  $('#wms-info-tabs').append(
                    '<li class="first active"><a href="#' +
                      rawlabel +
                      '-' +
                      idx +
                      '-tab">' +
                      getLabelFromID({ id: rawlabel2 || rawlabel, state }) +
                      '</a></li>',
                  );
                else
                  $('#wms-info-tabs').append(
                    '<li class=""><a href="#' +
                      rawlabel +
                      '-' +
                      idx +
                      '-tab">' +
                      getLabelFromID({ id: rawlabel2 || rawlabel, state }) +
                      '</a></li>',
                  );
              }
              if ($.isArray(feature.feature)) {
                feature.feature = feature.feature[0];
              }
              var wmstop = '';
              var wmsbody = '';
              var wmsmain = '';
              var wmsfoot = '';
              var wmsfoot2 = '';
              var wmsextra = '';
              if (index === 0)
                wmsbody +=
                  "<div class='tab-pane active' id='" +
                  rawlabel +
                  '-' +
                  idx +
                  "-tab'><table><tr><td><div style='padding-right: 5px; max-height: 450px; overflow-y: auto;'><table>";
              else
                wmsbody +=
                  "<div class='tab-pane' id='" +
                  rawlabel +
                  '-' +
                  idx +
                  "-tab'><table><tr><td><div style='padding-right: 5px; max-height: 450px; overflow-y: auto;'><table>";
              $.each(feature.properties, function (key, value) {
                if (key == 'flagged') {
                  var cls = '';
                  var img = 'flag.svg?id=4';
                  if (feature.properties.flagged === 'No' || feature.properties.flagged === '') {
                    cls = 'faded';
                  } else {
                    img = 'flag-orange.svg?id=4';
                  }
                  wmsextra =
                    "<div class='flag " +
                    cls +
                    "' data-ref='" +
                    feature.properties.ref.toString() +
                    "'><img src='/assets/img/" +
                    img +
                    "' style='width:56px;height:56px' /></div>";
                }
                if (value) {
                  var val = util.lookup(label.replace('title:', ''), key, value.toString());
                  if (typeof val !== 'undefined' && key != '#text' && val !== 'Null' && val !== '-' && val !== ' ') {
                    let excluded = false;
                    if (
                      util.exclude[rawlabel2 || rawlabel] &&
                      util.exclude[rawlabel2 ? rawlabel2 : rawlabel].includes(key)
                    ) {
                      excluded = true;
                    }
                    if (getPropFromID({ key, id: rawlabel2 || rawlabel, state }) && !excluded) {
                      if (val) val = util.spelling(val.trim());
                      if (util.modify(key, val, rawlabel2 || rawlabel)) {
                        if (key == 'source') {
                          if (feature.properties['lb_uid']) {
                            if (util.country == 'England')
                              wmsmain +=
                                intro +
                                "Listed Entry Number:</b></td> <td class='right-float' id='attr_" +
                                key +
                                "2'>" +
                                feature.properties['lb_uid'] +
                                '</td></tr>';
                            else
                              wmsmain +=
                                intro +
                                "Reference Number:</b></td> <td class='right-float' id='attr_" +
                                key +
                                "2'>" +
                                feature.properties['lb_uid'] +
                                '</td></tr>';
                          }
                        }
                        if (util.checkBottom(key))
                          wmsfoot +=
                            intro +
                            getPropFromID({ key, id: rawlabel, state }) +
                            ":</b></td> <td class='right-float' id='attr_" +
                            key +
                            "'>" +
                            util.modify(key, val, rawlabel2 || rawlabel) +
                            '</td></tr>';
                        else if (util.checkAbsBottom(key))
                          wmsfoot2 +=
                            intro +
                            getPropFromID({ key, id: rawlabel, state }) +
                            ":</b></td> <td class='right-float' id='attr_" +
                            key +
                            "'>" +
                            util.modify(key, val, rawlabel2 || rawlabel) +
                            '</td></tr>';
                        else if (util.checkTop(key))
                          wmstop +=
                            intro +
                            getPropFromID({ key, id: rawlabel, state }) +
                            ":</b></td> <td class='right-float' id='attr_" +
                            key +
                            "'>" +
                            util.modify(key, val, rawlabel2 || rawlabel) +
                            '</td></tr>';
                        else
                          wmsmain +=
                            intro +
                            getPropFromID({ key, id: rawlabel2 || rawlabel, state }) +
                            ":</b></td> <td class='right-float' id='attr_" +
                            key +
                            "'>" +
                            util.modify(key, val, rawlabel2 || rawlabel) +
                            '</td></tr>';
                      }
                    }
                  }
                }
              });
              if (rawlabel == '22' && rawlabel2 !== 'gla_conservation_areas') {
                wmsfoot += `<tr><td class='left-float'><b>More Info:</b></td><td class='right-float'><b><a href='https://www.north-norfolk.gov.uk/tasks/development-management/compulsory-purchase-orders/' target='_blank'>North Norfolk DC - CPOs</a></b></td>`;
              }
              if (rawlabel == '3') {
                wmsfoot += `<tr><td class='left-float'><b>More Info:</b></td><td class='right-float'><b><a href='https://www.north-norfolk.gov.uk/ldf/' target='_blank'>North Norfolk DC - Proposed Retail</a></b></td>`;
              }
              if (rawlabel == '36') {
                wmsfoot +=
                  "<tr><td class='left-float'><b>Responsibility:</b></td><td class='right-float'>Maintained at Public Expense</td>";
              }
              if (rawlabel2 == 'surface-water-3-3') {
                wmstop +=
                  "<tr><td class='left-float'><b>Risk:</b></td><td class='right-float'>High - High risk means that each year this area has a chance of flooding of greater than 3.3%. Flooding from surface water is difficult to predict as rainfall location and volume are difficult to forecast. In addition, local features can greatly affect the chance and severity of flooding.</td>";
              }
              if (rawlabel2 == 'surface-water-1') {
                wmstop +=
                  "<tr><td class='left-float'><b>Risk:</b></td><td class='right-float'>Medium - Medium risk means that each year this area has a chance of flooding of between 1% and 3.3%. Flooding from surface water is difficult to predict as rainfall location and volume are difficult to forecast. In addition, local features can greatly affect the chance and severity of flooding.</td>";
              }
              if (rawlabel2 == 'surface-water-0-1') {
                wmstop +=
                  "<tr><td class='left-float'><b>Risk:</b></td><td class='right-float'>Low - Low risk means that each year this area has a chance of flooding of between 0.1% and 1%. Flooding from surface water is difficult to predict as rainfall location and volume are difficult to forecast. In addition, local features can greatly affect the chance and severity of flooding.</td>";
              }
              if (
                rawlabel == 'ea_flood' ||
                rawlabel == 'vw_rofrs' ||
                rawlabel == 'vw_rofrs_157' ||
                rawlabel == 'rofrs_ea_v201905' ||
                rawlabel2 == 'surface-water-3-3' ||
                rawlabel2 == 'surface-water-1' ||
                rawlabel2 == 'surface-water-0-1'
              ) {
                wmsfoot +=
                  "<tr><td class='left-float'><b>Link:</b></td><td class='right-float'><b><a href='https://flood-warning-information.service.gov.uk/long-term-flood-risk/map?easting=" +
                  state.mousePos.lon +
                  '&northing=' +
                  state.mousePos.lat +
                  "' target='_blank'>EA Flood Risk</a></b></td>";
              }
              if (rawlabel == 'Special_Areas_of_Conservation_England') {
                wmsfoot += `<tr><td class='left-float'><b>More Info:</b></td><td class='right-float'><b><a href='https://jncc.gov.uk/jncc-assets/sac-n2k/${feature.properties.sac_code.trim()}.pdf' target='_blank'>SAC PDF</a></b></td>`;
              }
              if (rawlabel == 'Special_Protection_Areas_England') {
                wmsfoot += `<tr><td class='left-float'><b>More Info:</b></td><td class='right-float'><b><a href=' https://jncc.gov.uk/jncc-assets/SPA-N2K/${feature.properties.spa_code.trim()}.pdf' target='_blank'>SPA PDF</a></b></td>`;
              }
              if (rawlabel == 'NRW_SPA') {
                wmsfoot += `<tr><td class='left-float'><b>More Info:</b></td><td class='right-float'><b><a href=' https://jncc.gov.uk/jncc-assets/SPA-N2K/${feature.properties.SPA_code.trim()}.pdf' target='_blank'>SPA PDF</a></b></td>`;
              }
              if (rawlabel == 'NRW_SAC') {
                wmsfoot += `<tr><td class='left-float'><b>More Info:</b></td><td class='right-float'><b><a href=' https://jncc.gov.uk/jncc-assets/sac-n2k//${feature.properties.Site_code.trim()}.pdf' target='_blank'>SAC PDF</a></b></td>`;
              }
              if (rawlabel == 'vw_ufmfsw') {
                wmsfoot +=
                  "<tr><td class='left-float'><b>Link:</b></td><td class='right-float'><b><a href='https://naturalresources.wales/flooding/managing-flood-risk/flood-risk-map-guidance/low-risk-of-flooding-from-surface-water/?lang=en' target='_blank'>Natural Resources Wales</a></b></td>";
                wmsfoot +=
                  "<tr><td class='left-float'><b>Link:</b></td><td class='right-float'><b><a href='https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/842485/What-is-the-Risk-of-Flooding-from-Surface-Water-Map.pdf' target='_blank'>Data Layer Explanation Document</a></b></td>";
              }
              if (
                rawlabel2 == 'surface-water-3-3' ||
                rawlabel2 == 'surface-water-0' ||
                rawlabel2 == 'surface-water-0-1'
              ) {
                wmsfoot +=
                  "<tr><td class='left-float'><b>Link:</b></td><td class='right-float'><b><a href='https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/842485/What-is-the-Risk-of-Flooding-from-Surface-Water-Map.pdf' target='_blank'>Data Layer Explanation Document</a></b></td>";
              }
              if (rawlabel.indexOf('tb_hs2') == 0) {
                var conv = new GT_OSGB();
                conv.setGridCoordinates(pos.lon, pos.lat);
                var wgs = conv.getWGS84();
                wmsfoot2 +=
                  "<tr><td class='left-float'><b>Link:</b></td><td class='right-float'><b><a href='https://www.hs2.org.uk/where/route-map/#16/" +
                  wgs.latitude +
                  '/' +
                  wgs.longitude +
                  "' target='_blank'>HS2 Route Map</a></b></td>";
              }
              if (rawlabel.indexOf('authorised_landfill_sites') == 0) {
                if (
                  ['Closure', 'Effective', 'Expired', 'Suspended', 'Transfer Effective'].indexOf(
                    feature.properties.status,
                  ) === -1
                ) {
                  if (!feature.properties.lic_epr || feature.properties.lic_epr == '') {
                    // || feature.properties.status == "Transferred") {
                    wmsfoot2 +=
                      "<tr><td class='left-float'><b>Link:</b></td><td class='right-float'><b><a href='https://environment.data.gov.uk/public-register/view/search-all' target='_blank'>Licence search</a></td></tr>";
                  } else {
                    var licval = feature.properties.lic_epr.replace('EAEPR\\EA/EPR/', '').replace('/', '-');
                    wmsfoot2 +=
                      "<tr><td class='left-float'><b>Link:</b></td><td class='right-float'><b><a href='https://environment.data.gov.uk/public-register/waste-operations/registration/" +
                      licval +
                      "' target='_blank'>Licence</a></td></tr>";
                  }
                }
              }
              if (rawlabel.indexOf('vw_os_highways_street') == 0) {
                if (feature.properties.designatedname1 && !feature.properties.roadname) {
                  wmstop +=
                    intro +
                    "Road Name:</b></td> <td class='right-float' id='attr_roadname'>" +
                    feature.properties.designatedname1 +
                    '</td></tr>';
                }
              }
              if (rawlabel.indexOf('vw_england_highways') === 0) {
                wmsfoot +=
                  intro +
                  "Description:</b></td><td class='right-float' id='attr_roadname'>" +
                  util.GetDescription(feature.properties.Origin) +
                  '</td></tr>';
                wmsfoot += `<tr><td class='left-float'><b>More Info:</b></td><td class='right-float'><b><a href='https://highways.maps.arcgis.com/apps/webappviewer/index.html?id=6db7a2db20d04c79ab2abe7947f8cc06' target='_blank'>Highways England</a></b></td>`;
              }
              if (rawlabel.indexOf('vw_designated_protected_areas') === 0) {
                if (feature.properties.parish_map_url && feature.properties.parish_map_url !== 'Null') {
                  wmsfoot += `<tr><td class='left-float'><b>Parish Map:</b></td><td class='right-float'><a href='${
                    feature.properties.parish_map_url
                  }' target='_blank'>${
                    feature.properties.partial_coverage_parish
                      ? feature.properties.partial_coverage_parish
                      : feature.properties.parish_name
                  }</a></td>`;
                }
              }
              if (rawlabel.indexOf('prow_full_find') == 0) {
                if (feature.properties.url && feature.properties.map == 'y') {
                  if (
                    feature.properties.editable_xy &&
                    feature.properties.xy_latlon == 'XY' &&
                    feature.properties.authority_code &&
                    util.PROWParams[feature.properties.authority_code]
                  ) {
                    feature.properties.url = updateQueryStringParameter(
                      feature.properties.url,
                      util.PROWParams[feature.properties.authority_code].x,
                      state.curMouseXY.lon,
                    );
                    feature.properties.url = updateQueryStringParameter(
                      feature.properties.url,
                      util.PROWParams[feature.properties.authority_code].y,
                      state.curMouseXY.lat,
                    );
                  }
                  wmsfoot +=
                    "<tr><td class='left-float'><b>Link:</b></td><td class='right-float'><b><a href='" +
                    feature.properties.url +
                    "' target='_blank'>Interactive Map</a></b></td>";
                } else if (feature.properties.url) {
                  wmsfoot +=
                    "<tr><td class='left-float'><b>Link:</b></td><td class='right-float'><b><a href='" +
                    feature.properties.url +
                    "' target='_blank'>Further Information</a></b></td>";
                }
              }
              if (rawlabel.search(/bgs_radon/) !== -1) {
                wmsmain = util.buildRadon(feature.properties.class_max);
              }
              var wmslogo = util.getLogo({ state, layer: rawlabel, layer2: rawlabel2 });
              const translatedLabel = translateLabel(rawlabel);
              const updated = translatedLabel.includes('highway')
                ? state.updatedData.find(o => o.view_name === 'OS Highways Live')
                : translatedLabel.includes('underground')
                ? state.updatedData.find(o => o.view_name === 'underground')
                : state.updatedData.find(o => o.view_name === translatedLabel);
              if (updated) {
                wmsfoot2 +=
                  "<tr><td class='left-float'><b>Dataset Last Updated:</b></td><td class='right-float'>" +
                  updated.last_updated +
                  '</td>';
              } else {
                if (feature.properties.extract_url && feature.properties.extract_url.search('hamlets') !== -1) {
                  wmstop +=
                    "<div class='orange' style='padding-bottom:5px'>WARNING - DATA FOR THIS LOCAL AUTHORITY IS TEMPORARILY NOT BEING UPDATED<br />LAST UPDATED: MARCH 2020</div>";
                } else if (
                  feature.properties.extract_url &&
                  feature.properties.extract_url.search('tandridge') !== -1
                ) {
                  wmstop +=
                    "<div class='orange' style='padding-bottom:5px'>WARNING - DATA FOR THIS LOCAL AUTHORITY IS TEMPORARILY NOT BEING UPDATED<br />LAST UPDATED: AUGUST 2019</div>";
                } else if (rawlabel2 && rawlabel2.includes('gla_')) {
                  wmsfoot2 +=
                    "<tr><td class='left-float'><b>Dataset Last Updated:</b></td><td class='right-float small_text'>London boroughs update their data independently and at different times, some more frequently than others</td>";
                } else {
                  wmsfoot2 +=
                    "<tr><td class='left-float'><b>Dataset Last Updated:</b></td><td class='right-float'>" +
                    moment().subtract(1, 'days').format('MMMM YYYY') +
                    '</td>';
                }
              }
              wmsbody +=
                wmstop + wmsmain + wmsfoot + wmsfoot2 + '</td></tr></table></div>' + wmslogo + '</table>' + wmsextra;
              var panelfoot = '';
              var numberDiv = '';
              if (featurearr.length > 1) {
                if (idx === 0) {
                  panelfoot =
                    "&lt; Prev | <a href='#' onclick='window.showTab(\"" +
                    rawlabel +
                    '",' +
                    (idx + 1) +
                    ',' +
                    idx +
                    ")'>Next &gt;</a>";
                } else if (idx < featurearr.length - 1) {
                  panelfoot =
                    "<a href='#' onclick='window.showTab(\"" +
                    rawlabel +
                    '",' +
                    (idx - 1) +
                    ',' +
                    idx +
                    ")'>&lt; Prev</a> | <a href='#' onclick='window.showTab(\"" +
                    rawlabel +
                    '",' +
                    (idx + 1) +
                    ',' +
                    idx +
                    ")'>Next &gt;</a>";
                } else if (idx == featurearr.length - 1) {
                  panelfoot =
                    "<a href='#' onclick='window.showTab(\"" +
                    rawlabel +
                    '",' +
                    (idx - 1) +
                    ',' +
                    idx +
                    ")'>&lt; Prev</a> | Next &gt;";
                }
                numberDiv = "<div class='itemNumber'>Page: " + (idx + 1) + ' of ' + featurearr.length + '</div>';
              }
              wmsbody += '<div class="bottom-floater">' + panelfoot + '</div>' + numberDiv;
              ol.arrays.wmsArray.push(wmsbody);
            });
          });
          for (var x = 0; x < ol.arrays.wmsArray.length; x++)
            $('#wms-info-panel .content').append(ol.arrays.wmsArray[x]);
        } else {
          if ($.isArray(features.feature)) {
            features.feature = features.feature[0];
          }
          var label = features.feature.pid ? features.feature.pid.split('.')[0] : features.feature.id.split('.')[0];
          let label2;
          if (features.feature.attributes && features.feature.attributes.fsProxy)
            label2 = features.feature.attributes.fsProxy;
          else if (state.wmsQuery && state.wmsQuery[label]) label2 = state.wmsQuery[label];
          else if (proxy) label2 = proxy;
          else if (features.feature.layer && features.feature.layer.proxy) label2 = features.feature.layer.proxy;
          var wmsbody = "<h4 style='text-align:center'>" + getLabelFromID({ id: label2 || label, state }) + '</h4>';
          var wmsfoot = '';
          var wmsextra = '';
          wmsbody += '<table>';
          $.each(features.properties, function (key, value) {
            if (value) {
              var val = util.str_tidy(value.toString());
              if (typeof val !== 'undefined' && key != '#text' && val !== 'Null' && val !== '-' && val !== ' ') {
                let excluded = false;
                if (util.exclude[label2 || label] && util.exclude[label2 ? label2 : label].includes(key)) {
                  excluded = true;
                }
                if (getPropFromID({ id: label, key, state }) && !excluded) {
                  if (val) val = val.trim();
                  if (util.modify(key, val, label2 || label)) {
                    if (util.checkBottom(key))
                      wmsfoot +=
                        intro +
                        getPropFromID({ id: label, key, state }) +
                        ":</b></td> <td class='right-float' id='attr_" +
                        key +
                        "'>" +
                        util.modify(key, val, label2 || label) +
                        '</td></tr>';
                    else
                      wmsbody +=
                        intro +
                        getPropFromID({ id: label, key, state }) +
                        ":</b></td> <td class='right-float' id='attr_" +
                        key +
                        '>' +
                        util.modify(key, val, label2 || label) +
                        '</td></tr>';
                  }
                }
              }
            }
          });
          const updated = label.includes('highway')
            ? state.updatedData.find(o => o.view_name === 'OS Highways Live')
            : label.includes('underground')
            ? state.updatedData.find(o => o.view_name === 'underground')
            : state.updatedData.find(o => o.view_name === label);
          if (updated) {
            wmsfoot +=
              "<tr><td class='left-float'><b>Dataset Last Updated:</b></td><td class='right-float'>" +
              updated.last_updated +
              '</td>';
          }

          wmsbody += wmsfoot + '</table>' + wmsextra;
          $('#wms-info-panel .content').append(wmsbody);
        }
        $('#wms-info-panel').show();
        ol.points.marker2 = new OpenLayers.Feature.Vector(pos2, null, {
          externalGraphic: 'assets/img/cross.png',
          graphicWidth: 32,
          graphicHeight: 32,
          fillOpacity: 1,
          display: 'block',
        });
        ol.layers.vectorPin.addFeatures([ol.points.marker2]);
        ol.map.raiseLayer(ol.layers.vectorPin, ol.map.layers.length);
        ol.layers.vectorPin.redraw();
        $('.flag')
          .off()
          .on('click', function () {
            var ref = $(this).data('ref').toString();
            var flagOn = false;
            if ($(this).css('opacity') == 1) {
              $(this).addClass('faded');
              $(this).find('img').attr('src', 'assets/img/flag.svg?id=4');
            } else {
              flagOn = true;
              $(this).removeClass('faded');
              $(this).find('img').attr('src', 'assets/img/flag-orange.svg?id=4');
            }
            $.each(ol.arrays.wmsFeatureArray, function (ix, featurearr) {
              $.each(featurearr, function (idx, feature) {
                $.each(feature.properties, function (key, value) {
                  if (key === 'ref' && value.toString() === ref.toString()) {
                    feature.properties.flagged = flagOn ? 'Yes' : '';
                  }
                });
              });
            });
            $.each(state.csvArray, function (idx, feat) {
              if (feat.ref.toString() == ref.toString()) {
                feat.flagged = flagOn ? 'Yes' : '';
              }
            });
          });
        $('#wms-info-tabs a').click(function (e) {
          e.preventDefault();
          $(this).tab('show');
        });
        if (ol.arrays.wmsFeatureArray['planningapplications']) {
          var item = ol.arrays.wmsFeatureArray['planningapplications'][0].attributes[0];
          if (!hasSeen({ item, state })) {
            state.seenItems.push(item);
            ServiceCalls.callService('logPlanningView', {
              guid: guid,
              xy: '(' + state.planningCenter.x + ',' + state.planningCenter.y + ')',
            });
            //                      if (!skipPlanningLog)
            logPlanningView({ item, state, settings });
          }
        }
      }
    }
  }
  setCursor({ type: 'help' });
}
